// -- React Libraries
import React from 'react';

// -- Components
import MediaQuery from 'react-responsive';
import Swipeable from 'react-swipeable';

import GridHeader from "../GridHeader/index";
import GridContent from "../GridContent/index";

// -- Styles
import StyleWrapper from "./Wrapper";

class Screenshots extends React.Component {
    constructor (props) {
        super(props);

        this.urlCollection = props.urls;
        this.right = -1;
        this.left = +1;
        this.state = { imageIndex: 0 };
    }

    onSwiped(operator) {
        var index = this.state.imageIndex + operator;
        if (index < 0) index = this.urlCollection.length - 1;
        if (index >= this.urlCollection.length) index = 0;
        
        this.setState({ imageIndex: index });
    }

    render() {
        {
            var screenshotComponents = this.urlCollection.map(function(url, index) {
                return (<div key={index}><img src={url}/></div>);
            });
            var bubbleComponents = this.urlCollection.map(function(url, index) {
                return (<div key={index} className={`shot-bubble ${ this.state.imageIndex == index ? "activated-shot-bubble" : "" }`} />)
            }.bind(this));
        }
        return (
            this.urlCollection && this.urlCollection.length > 0 && (
                <div className="screenshots">
                    <MediaQuery minWidth={768}>
                        {screenshotComponents}
                    </MediaQuery>

                    <MediaQuery maxWidth={767}>
                    {
                        <Swipeable 
                            className="swipe"
                            trackMouse
                            style={{ touchAction: 'none' }}
                            preventDefaultTouchmoveEvent
                            onSwipedLeft={()=>this.onSwiped(this.left)}
                            onSwipedRight={()=>this.onSwiped(this.right)}
                        >
                            <img src={this.urlCollection[this.state.imageIndex]}/>
                        </Swipeable>
                    }
                    </MediaQuery>

                    <div className="shot-bubbles">
                        {bubbleComponents}
                    </div>
                </div>
            )
        );
    }
}

export default class GridGraphics extends React.Component {
    constructor (props) {
        super(props);
        
        this.screenshots = props.data.screenshots;
        this.isQuantityOk = props.data.isQuantityOk;
        this.isShapeOk = props.data.isShapeOk;
        this.isPreviewVideoOk = props.data.isPreviewVideoOk;
    }

    render() {
        return (
            <StyleWrapper className="grid-score-summaries">
                <div className="summary-title">屏幕截图</div>

                <Screenshots urls={this.screenshots}/>
                
                <div className="grid-container">
                    {/* First Row */}
                    <GridHeader ok={this.isQuantityOk} title="数量"></GridHeader>
                    <GridHeader ok={this.isShapeOk} title="形状"></GridHeader>
                    <GridHeader ok={this.isPreviewVideoOk} title="预览影片"></GridHeader>

                    {/* Second Row */}
                    <GridContent title={this.isQuantityOk && "很好！"}>
                        {
                            this.isQuantityOk && (
                                <div>
                                    你充分<span>运用了五张屏幕截图。</span>
                                </div>
                            ) || (
                                <div>
                                    {
                                        this.screenshots.length > 5 &&
                                        "你的屏幕截图太多，把数量控制在五张以内。" ||
                                        "你的屏幕截图太少，把数量控制在五张以内。"
                                    }
                                </div>
                            )
                        }
                    </GridContent>

                    <GridContent title={this.isShapeOk && "很好！"}>
                        {
                            this.isShapeOk && (
                                <div>
                                    你的屏幕截图都保持垂直。
                                </div>
                            ) || (
                                <div>你应该把屏幕截图保持<span>垂直。</span></div>
                            )
                        }
                    </GridContent>

                    <GridContent title={this.isPreviewVideoOk && "很好！"}>
                        {
                            this.isPreviewVideoOk && (
                                <div>
                                    你有一个预览影片。
                                </div>
                            ) || (
                                <div>
                                    你应该要在截图部分加入<span>预览影片。</span>
                                </div>
                            )
                        }
                    </GridContent>
                    
                    {/* Third Row */}
                    <GridContent title={"小窍门:"}>
                        <div>
                        - 利用屏幕截图介绍应用的<span>功能和特点</span>
                        </div>

                        <div>
                        - 在屏幕截图中加入文字能够令用户更加明白应用的功能。
                        </div>

                    </GridContent>
                    
                    <GridContent title={"小窍门:"}>
                        - 若你的屏幕截图保持垂直，能让手机用户在<span>窄长的页面</span>看到更多截图。
                        <br /><br />

                        - 不妨在屏幕截图中加入文字，但谨记使用一个<span>简洁的背景。</span>
                    </GridContent>
                    
                    <GridContent title={"小窍门:"}>
                        <div>- 充分利用<span>首五秒</span>获得用户的关注</div>
                        <div>- 要展示出应用中<span>最好的功能</span></div>
                        <div>- 你的预览影片要在静音的情况下也能让用户明白</div>
                        <div>- 影片中不要忘了包含<span>CTA（用户行为号召）</span>在内</div>
                    </GridContent>
                </div>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/GridGraphics/index.js